<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអតិថិជន</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវឱ្យបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>ឈ្មោះអតិថិជន *</label>
							<md-input type="text" v-model="client.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>លេខទូរស័ព្ទអតិថិជន *</label>
							<md-input type="text" v-model="client.phone"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<label>ទីតាំង *</label>
						<v-select label="full_name" inputId="id" :clearable="false" :options="locationList"
							v-model="client.locationArray">
						</v-select>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<label>អ្នកទីផ្សារ *</label>
						<v-select label="name" inputId="id" :clearable="false" :options="referralList"
							v-model="client.referralArray">
						</v-select>
					</div>
					<!-- <div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>តេឡេក្រាម Link</label>
							<md-input type="text" v-model="client.telegram_link">
							</md-input>
						</md-field>
					</div> -->
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>ទំតាំង Link</label>
							<md-input type="text" v-model="client.location_link">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>កំណត់សំគាល់</label>
							<md-input type="text" v-model="client.description">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ពាក្យសម្ងាត់ថ្មី *</label>
							<md-input type="password" v-model="client.password">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>បញ្ជាក់ពាក្យសម្ងាត់ថ្មី *</label>
							<md-input type="password" v-model="client.confirm_password">
							</md-input>
						</md-field>
					</div>

					<div class="md-layout-item md-small-size-100 md-size-50 text-center">
						<div style="width:100%">
							<p>គណនី USD</p>
							<input type="file" ref="image_usd" accept="image/*" style="display: none;" @change="processFileUSD($event)">
							<img class="thumb-profile" :src="config.getProfileUrl()" v-if="client.bank_usd.length == 0">
							<img class="thumb-profile" :src="config.getProfileUrl(client.bank_usd)" v-if="client.bank_usd.length > 0">
						</div>
						<md-button class="md-primary" @click="openUSD()" v-if="client.bank_usd.length == 0">បញ្ចូលរូបភាព</md-button>
						<md-button class="md-danger" @click="removeUSD()" v-else>លុបចោល</md-button>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50 text-center">
						<div style="width:100%">
							<p>គណនី KHR</p>
							<input type="file" ref="image_khr" accept="image/*" style="display: none;" @change="processFileKHR($event)">
							<img class="thumb-profile" :src="config.getProfileUrl()" v-if="client.bank_khr.length == 0">
							<img class="thumb-profile" :src="config.getProfileUrl(client.bank_khr)" v-if="client.bank_khr.length > 0">
						</div>
						<md-button class="md-primary" @click="openKHR()" v-if="client.bank_khr.length == 0">បញ្ចូលរូបភាព</md-button>
						<md-button class="md-danger" @click="removeKHR()" v-else>លុបចោល</md-button>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50 text-center">
						<div style="width:100%">
							<p>គណនី Telegram</p>
							<input type="file" ref="image_telegram" accept="image/*" style="display: none;" @change="processFileTelegram($event)">
							<img class="thumb-profile" :src="config.getProfileUrl()" v-if="client.telegram_qr.length == 0">
							<img class="thumb-profile" :src="config.getProfileUrl(client.telegram_qr)" v-if="client.telegram_qr.length > 0">
						</div>
						<md-button class="md-primary" @click="openTelegram()" v-if="client.telegram_qr.length == 0">បញ្ចូលរូបភាព</md-button>
						<md-button class="md-danger" @click="removeTelegram()" v-else>លុបចោល</md-button>
					</div>

				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">ឈ្មោះអតិថិជន</md-table-cell>
							<md-table-cell style="width: 5px">៖</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.name).length > 0">{{client.name}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
							<md-table-cell>៖</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ទំតាំង</md-table-cell>
							<md-table-cell>៖</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.location_id).length > 0">{{client.locationArray.name}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>អ្នកទីផ្សារ</md-table-cell>
							<md-table-cell>៖</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.referral_id).length > 0">{{client.referralArray.name}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<!-- <md-table-row>
							<md-table-cell>តេឡេក្រាម Link</md-table-cell>
							<md-table-cell>៖</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.telegram_link).length > 0">{{client.telegram_link}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row> -->
						<md-table-row>
							<md-table-cell>ទីតាំង Link</md-table-cell>
							<md-table-cell>៖</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.location_link).length > 0">{{client.location_link}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កំណត់សំគាល់</md-table-cell>
							<md-table-cell>៖</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.description).length > 0">{{client.description}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateClient()">កែប្រែ</md-button>
			</div>
		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getLocation();
		},
		watch: {
			'client.referralArray': function (val) {
				if (String(this.client.referralArray).length > 5) {
					this.client.referral_id = this.client.referralArray.id;
				} else {
					this.client.referral_id = "";
				}
			},
			'client.locationArray': function (val) {
				if (String(this.client.locationArray).length > 5) {
					this.client.location_id = this.client.locationArray.id;
				} else {
					this.client.location_id = "";
				}
			}
		},
		data() {
			return {
				loaded: false,
				client: {
					id: "",
					name: "",
					phone: "",
					description: "",
					bank_usd: "",
					bank_khr: "",
					telegram_qr: "",
					telegram_link: "",
					location_link: "",
					referral_id: "",
					referralArray: "",
					location_id: "",
					locationArray: "",
					password: "",
					confirm_password: "",
					old_password: ""
				},
				locationList: [],
				referralList: []
			}
		},
		methods: {
			getReferral() {
				this.$http.post(this.config.api + "/admin/referral/search", { text: "", offset: 0}).then(data => {
					this.referralList = data.body.data;
					this.getClient();
				});
			},
			getLocation() {
				this.$http.get(this.config.api + "/admin/zone/get/location_list").then(data => {
					this.locationList = data.body.data
					this.getReferral();
				});
			},
			getClient() {
				this.$http.get(this.config.api + '/admin/client/get/' + this.$route.params.hash_id).then(data => {
					this.client.id = data.body.data.id
					this.client.name = data.body.data.name
					this.client.phone = data.body.data.phone
					this.client.description = data.body.data.note
					this.client.bank_usd = data.body.data.bank_usd
					this.client.bank_khr = data.body.data.bank_khr
					this.client.telegram_qr = data.body.data.telegram_qr
					this.client.telegram_link = data.body.data.telegram_link
					this.client.location_link = data.body.data.location_link
					this.client.location_id = data.body.data.location_id
					this.client.referral_id = data.body.data.referral_id
					this.client.old_password = data.body.data.password

					for(let i = 0; i < this.referralList.length; i++) {
						if(this.client.referral_id == this.referralList[i].id) {
							this.client.referralArray = this.referralList[i];
						}
					}
					for(let i = 0; i < this.locationList.length; i++) {
						if(this.client.location_id == this.locationList[i].id) {
							this.client.locationArray = this.locationList[i];
						}
					}
					this.loaded = true
				})
			},
			updateClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/update", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "ព័ត៌មានត្រូវបានកែប្រែដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.$router.push("/clients");
					}
				})
			},
			checkValidation() {

				if (String(this.client.name).length > 0 && String(this.client.phone).length > 0 && String(this.client.bank_usd).length > 0 && String(this.client.bank_khr).length > 0 && String(this.client.telegram_qr).length > 0 && String(this.client.location_id).length > 0) {
					if (String(this.client.password) == String(this.client.confirm_password)) {
						return true;
					} else {
						this.$notification.notify({
							message: "ពាក្យសម្ងាត់ និង បញ្ជាក់ពាក្យសម្ងាត់មិនដូចគ្នា។ ពាក្យសម្ងាត់ត្រូវចាប់ពី ៦អក្សរឡើង",
							icon: 'error',
							type: 'danger'
						})
					}
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			processFileUSD(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.bank_usd = res.body.data.file_hash.replace(".jpg", "");
					}
				})
			},
			processFileKHR(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.bank_khr = res.body.data.file_hash.replace(".jpg", "");
					}
				})
			},
			processFileTelegram(e, image) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				let formData = new FormData();

				formData.append("image", files[0], 'imagepro');
				this.$http.post(this.config.api + '/admin/client/upload', formData).then(res => {
					if (res.body.status == 'success') {
						this.client.telegram_qr = res.body.data.file_hash.replace(".jpg", "");
					}
				})
			},
			openUSD() {
				this.$refs['image_usd'].click();
			},
			openKHR() {
				this.$refs['image_khr'].click();
			},
			openTelegram() {
				this.$refs['image_telegram'].click();
			},
			removeTelegram(id) {
				this.client.telegram_qr = "";
			},
			removeUSD(id) {
				this.client.bank_usd = "";
			},
			removeKHR(id) {
				this.client.bank_khr = "";
			},
			
			clearAll() {
				this.client = {
					id: "",
					name: "",
					phone: "",
					description: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Edit.vue